import {FilterOptionVo} from '../../common/shared/api/karina/vo/FilterOptionVo.interface';
import {SortOptVo} from '../../common/shared/api/nicolas/vo/SortOptVo.interface';
import {SortOption} from '../generated/types';

export function createSortOption(
  param:
    | {
        sortOptVo: SortOptVo;
      }
    | {
        filterOptionVo: FilterOptionVo;
      }
): SortOption {
  if ('sortOptVo' in param) {
    return withSortOptVo(param.sortOptVo);
  } else {
    return withFilterOptionVo(param.filterOptionVo);
  }
}

function withSortOptVo({name, param}: SortOptVo): SortOption {
  return {name, param, id: param};
}

function withFilterOptionVo({name, param}: FilterOptionVo): SortOption {
  return {name, param, id: param};
}
